import { styled } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useEffect } from "react";

export const CMDatePicker = styled(DatePicker)(({ theme }) => ({
  '& .MuiInputBase-root': {
    position: 'relative', 

    '& .MuiInputAdornment-root': {
      position: 'absolute',
      right: 0,
      top: '30%',
      transform: 'translateY(-50%)',
      '& button': {
        padding: '0 20px', 
        paddingBottom:"10px"
      }
    },

    '& input': {
      border: "none",
      borderLeft: `solid 1px #e7e7e7`,
      padding: '4px 32px 4px 8px !important',
      backgroundColor: "white",
    }
  }
}));

const CustomDatePicker = (props) => {
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = `
        .MuiPaper-root {
            position: absolute !important;
        }

        .datepicker {
            background-color: white !important;
            margin-top:8px;
          }
    `;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  return <CMDatePicker {...props} />;
};

export default CustomDatePicker;
